/* eslint-disable react/require-default-props, jsx-a11y/label-has-for */
import PropTypes from 'prop-types';
import React from 'react';
import { fieldInputPropTypes, fieldMetaPropTypes } from 'redux-form';
import formClassName from '../../../../shared/helpers/formClassName';

const InputText = ({
  required,
  input,
  inputID,
  label,
  type,
  labelClassName,
  inputClassName,
  placeholder,
  disabled,
  max,
  min,
  skipTouchedValidation,
  hidden,
  meta: { touched, error, warning },
}) => {
  if (hidden) {
    return null;
  }
  return (
    <div
      className={
        formClassName(
          type,
          touched,
          skipTouchedValidation,
          error,
          disabled,
          warning,
        ).formErrorClass
      }
    >
      {label && (
        <label htmlFor={inputID} className={labelClassName}>
          {label}
          {' '}
          {required && <span className="requiredField">*</span>}
        </label>
      )}
      <div className={inputClassName}>
        <input
          className={formClassName(
            type,
            touched,
            skipTouchedValidation,
            error,
            disabled,
            warning,
          ).validationFeedback}
          {...input}
          placeholder={placeholder || (required ? 'required' : '')}
          type={type}
          id={inputID}
          disabled={disabled}
          readOnly={disabled}
          max={max}
          min={min}
        />
        {(touched || skipTouchedValidation)
          && ((error && <div className="invalid-feedback">{error}</div>)
            || (warning && <div className="invalid-feedback invalid-feedback-warn">{warning}</div>))}
      </div>
    </div>
  );
};

InputText.propTypes = {
  input: PropTypes.shape(fieldInputPropTypes).isRequired,
  meta: PropTypes.shape(fieldMetaPropTypes).isRequired,
  label: PropTypes.string,
  autoFocus: PropTypes.bool,
  required: PropTypes.bool,
  inputID: PropTypes.string,
  placeholder: PropTypes.string,
  type: PropTypes.string,
  labelClassName: PropTypes.string,
  inputClassName: PropTypes.string,
  disabled: PropTypes.bool,
  max: PropTypes.string,
  min: PropTypes.string,
  skipTouchedValidation: PropTypes.bool,
  hidden: PropTypes.bool,
};
InputText.defaultProps = {
  label: null,
  autoFocus: false,
  required: false,
  inputID: null,
  placeholder: null,
  type: 'text',
  labelClassName: 'text-left col-12',
  inputClassName: 'col-12',
  disabled: false,
  max: null,
  min: null,
  skipTouchedValidation: false,
  hidden: false,
};

export default InputText;
